import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_CONTENT_CLASS,
  TItemContentProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemContent: FC<TItemContentProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="ItemContent"
    className={cn(ITEM_CONTENT_CLASS, className)}
  >
    { children }
  </div>
);

ItemContent.displayName = "ItemContent";
